import { render, staticRenderFns } from "./userManage-setting.vue?vue&type=template&id=3b4a6f42"
import script from "./userManage-setting.vue?vue&type=script&lang=js"
export * from "./userManage-setting.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports